module.exports = __webpack_public_path__ + "img/logo.95941bd1.png";